export default "__VITE_ASSET__BWK0NjGv__"